import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsCopilotWidgetActive } from 'copilot-toolkit/hooks/useIsCopilotWidgetActive';
import CopilotActionButton from 'ai-components-ui-library/components/buttons/CopilotActionButton';
import { createWebInteractiveCopilotAction } from '../../../utils/copilotActionUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const SummarizeCtaAction = ({
  interactiveId,
  name
}) => {
  const isCopilotWidgetActive = useIsCopilotWidgetActive();
  return /*#__PURE__*/_jsx(CopilotActionButton, {
    copilotAction: createWebInteractiveCopilotAction({
      objectId: String(interactiveId),
      label: name
    }),
    disabled: !isCopilotWidgetActive,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actionMenu.summarizeTooltip"
    }),
    text: I18n.text('actionMenu.summarize'),
    useBreezeStyles: false,
    size: "extra-small"
  });
};
export default SummarizeCtaAction;